module.exports = {
	"layout": "frontPage",
	"brand": "se"
};


//////////////////
// WEBPACK FOOTER
// ./se/index.yaml
// module id = 668
// module chunks = 0